import { formatter, request } from '@/utils/request';

export namespace BOHQ {
  export const Path = {
    Query: '/expenseapi/bohq/query',
    Search: '/expenseapi/bohq/search',
    AjaxSearch: '/expenseapi/bohq/ajaxSearch',
    SearchMkt: '/expenseapi/bohq/searchMkt',
    AjaxSearchMkt: '/expenseapi/bohq/ajaxSearchMkt',
    SearchAll: '/expenseapi/bohq/searchAll',
    QueryForSheet: '/expenseapi/bohq/queryForSheet',
    AjaxSearchAll: '/expenseapi/bohq/ajaxSearchAll',
    Get: '/expenseapi/bohq/get',
    Post: '/expenseapi/bohq/post',
    Delete: '/expenseapi/bohq/delete',
    GetEx: '/expenseapi/bohq/getEx',
    Export: '/expenseapi/bohq/export',
    getForPd: '/expenseapi/bohq/getForPd',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.QueryForBOHQData>>(Path.Query, formatter(options));
  }

  export async function queryForSheet(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.QueryForSheet, formatter(options));
  }

  export async function search(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function searchMkt(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.SearchMkt, formatter(options));
  }

  export async function ajaxSearchMkt(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.AjaxSearchMkt, formatter(options));
  }

  export async function searchAll(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.SearchAll, formatter(options));
  }

  export async function ajaxSearchAll(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BOHQ[]>>(Path.AjaxSearchAll, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.BOHQ>>(Path.Get, formatter(options));
  }

  export async function getEx(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.BohqQuery>>(Path.GetEx, formatter(options));
  }

  export async function exportBohq(body: API.BOHQFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<API.BohqQuery[]>>(Path.Export, formatter(options));
  }

  export async function post(body: API.BOHQ) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }

  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }

  export async function getForPd() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<API.BOHQ>>(Path.getForPd, formatter(options));
  }
}
